import { useState, useEffect, useCallback } from "react";
import { API } from '../api';
import { useQueryContext } from './QueryContext';

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  const fetchIsAuthenticated = async () => {
    try {
      const response = await API.GET_ISAUTH();
      setIsAuthenticated(response.authenticated === "true")
    } catch (error) {
      console.error('Failed to fetch authentication info:', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchIsAuthenticated();
  }, []);

  return {isAuthenticated, loading}
};

export const useApiCall = () => {
  const { startQuery, endQuery } = useQueryContext();

  const executeQuery = useCallback(async (apiCall, queryId, options = {}) => {
    // Generate a unique query ID if not provided
    const id = queryId || `query_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    
    try {
      // Only trigger global loading indicator if this is not a pagination query
      if (!options.isPagination) {
        startQuery(id);
      }
      
      const result = await apiCall();
      return result;
    } catch (error) {
      console.error('API call failed:', error);
      throw error;
    } finally {
      // Always end the query tracking
      if (!options.isPagination) {
        endQuery(id);
      }
    }
  }, [startQuery, endQuery]);

  return { executeQuery };
};
